import { useMutation, useQueryClient } from '@tanstack/react-query';
import { serviceServices } from '../services/service.service';
import toast from 'react-hot-toast';

export const useDeleteService = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: serviceServices.deleteService,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['services'] });
      toast.success('Service deleted successfully');
    },
    onError: (error) => {
      toast.error(error?.response?.data?.message || 'Failed to delete service');
    },
  });
};
